//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { UnmeteredParkingLargeSVG } from './svg'

interface UnmeteredParkingLargeIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const UnmeteredParkingLargeIcon: React.FC<UnmeteredParkingLargeIconProps> = forwardRef<
  UnmeteredParkingLargeIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon
    ref={ref}
    boxSize={boxSize}
    as={UnmeteredParkingLargeSVG}
    sx={sx}
  />
))
